import EventBus from "../event-bus";
import { type DialogPayload } from "../event-payloads";

const setupDialogListener = (eventBus: EventBus) => {
  eventBus.on<DialogPayload>("dialog:close", ({ targetId }) => {
    const dialog = document.getElementById(targetId) as HTMLDialogElement;

    if (dialog) {
      dialog.close();
    }
  });

  eventBus.on<DialogPayload>("dialog:open", ({ targetId }) => {
    const dialog = document.getElementById(targetId) as HTMLDialogElement;

    if (dialog) {
      dialog.showModal();
    }
  });
};

export { setupDialogListener };
